import React, { useEffect, useState } from 'react';
import DrawerShell from './DrawerShell';
import { Commercial, VipAccount } from '../PanelComerciales.types';
import { VALIDITY_PERMANENT, validityOptionToDate } from '../utils/vipValidity';
import { OwnerSelectField, ValiditySelectField } from './VipFields';
import VipDrawerActions from './VipDrawerActions';

export interface VipEditChange {
    sellerId: number;
    validity?: string;
}

interface EditVipDrawerProps {
    open: boolean;
    vip: VipAccount | null;
    commercials: Commercial[];
    onClose: () => void;
    onSave: (vip: VipAccount, change: VipEditChange) => void;
}

const EditVipDrawer: React.FC<EditVipDrawerProps> = ({
    open,
    vip,
    commercials,
    onClose,
    onSave,
}) => {
    const [ownerId, setOwnerId] = useState<number | ''>('');
    const [validity, setValidity] = useState<string>(VALIDITY_PERMANENT);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (open && vip) {
            const current = commercials.find((c) => c.name === vip.owner);
            setOwnerId(current?.id ?? '');
            setValidity(VALIDITY_PERMANENT);
            setError(null);
        }
    }, [open, vip, commercials]);

    if (!vip) return null;

    const submit = () => {
        if (!ownerId) return setError('Selecciona un comercial');
        onSave(vip, {
            sellerId: ownerId,
            validity: validityOptionToDate(validity),
        });
        onClose();
    };

    return (
        <DrawerShell
            open={open}
            title='Editar cuenta VIP'
            description={`${vip.client} · ${vip.email}`}
            onClose={onClose}
        >
            <OwnerSelectField
                value={ownerId}
                commercials={commercials}
                onChange={setOwnerId}
            />
            <ValiditySelectField
                value={validity}
                onChange={setValidity}
                helperText={`Vigencia actual: ${vip.validity}`}
            />
            <VipDrawerActions
                error={error}
                submitLabel='Guardar'
                onCancel={onClose}
                onSubmit={submit}
            />
        </DrawerShell>
    );
};

export default EditVipDrawer;
